import { application } from "./application"

import NameSearchController from "./name_search_controller"
import ChatController from "./chat_controller"
import LogBookFormController from "./logbook_form_controller"
import SimpleFilterController from "./simple_filter_controller";
import FaaSearchController from "./faa_search_controller";
import AircraftAutocompleteController from "./aircraft_autocomplete_controller"
import AircraftSelectionController from "./aircraft_selection_controller"
import AdAutocompleteController from "./ad_autocomplete_controller"
import HelpPanelController from "./help_panel_controller"
import AdChatController from "./ad_chat_controller"
import RegistrationFormController from "./registration_form_controller"
import ComplianceNotesController from "./compliance_notes_controller"
import AircraftFormController from "./aircraft_form_controller"
import SubmitOnceController from "./submit_once_controller"
import CustomFieldDefinitionFormController from "./custom_field_definition_form_controller"

application.register("name-search", NameSearchController)
application.register("chat", ChatController)
application.register("logbook-form", LogBookFormController)
application.register("simple-filter", SimpleFilterController);
application.register("faa-search", FaaSearchController);
application.register("aircraft-autocomplete", AircraftAutocompleteController)
application.register("aircraft-selection", AircraftSelectionController)
application.register("ad-autocomplete", AdAutocompleteController)
application.register("help-panel", HelpPanelController)
application.register("ad-chat", AdChatController)
application.register("registration-form", RegistrationFormController)
application.register("compliance-notes", ComplianceNotesController)
application.register("aircraft-form", AircraftFormController)
application.register("submit-once", SubmitOnceController)
application.register("custom-field-definition-form", CustomFieldDefinitionFormController)

// Log what we know we registered (avoid private internals)
const registered = ["name-search", "chat", "logbook-form"]
console.log("Stimulus controllers registered:", registered)